var _rect, _g, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUncheckedMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 7,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2713_5736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6282 10.6153C23.1332 10.1196 22.3293 10.1199 21.8336 10.6153L13.7566 18.6926L10.1667 15.1028C9.671 14.6071 8.86748 14.6071 8.37178 15.1028C7.87607 15.5985 7.87607 16.402 8.37178 16.8977L12.8589 21.3849C13.1066 21.6326 13.4314 21.7567 13.7562 21.7567C14.0811 21.7567 14.4062 21.6329 14.6539 21.3849L23.6282 12.4102C24.1239 11.9148 24.1239 11.111 23.6282 10.6153Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 7,
    stroke: "black",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2713_5736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncheckedMark);
export default __webpack_public_path__ + "static/media/unchecked-mark.869d1642d3c58b8a3b08d658aa7d548a.svg";
export { ForwardRef as ReactComponent };